<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Edição' : 'Cadastro'} de usuário`">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="id"
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content :noCardStyle="!!id">
                <Form :id="id" ref="Form" @save="handleSave" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/cadastro/usuario/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {
            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList()
            })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        redirectToList() {
            this.$router.push({ name: 'cadastro-usuario-index' })
        }
    },
    props: {
        id: { type: Number, default: null }
    },
    created() {

        this.setShowExitFormConfirmation()
    }
}
</script>